/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/710/interface/api
 */

import { message } from 'ant-design-vue'
import { ref } from 'vue'
import {
  v1_jira_getAllProjects_get,
  v1_jira_getProjectById_post,
  v1_jira_searchByJQL_post
} from 'server/modules/4321'
const defaultProjects = [
  'PLM',
  'IMS',
  'OMS',
  'OFS',
  'SHOPIFY',
  'TMS',
  'CRM',
  'APP'
]
// 获取jira全部项目
export const v1_jira_getAllProjects_get_ = function(params) {
  const jiraProjects = ref([])
  const localJiraProject = ref([])
  const activeKey = ref(0)
  const getAllProjects = async () => {
    const { success, data, retInfo } = await v1_jira_getAllProjects_get(params)
    if (success) {
      jiraProjects.value = data.filter(_ => _.projectTypeKey === 'software')
      const loc_jira_project = localStorage.getItem('loc_jira_project')
      if (!loc_jira_project) {
        defaultProjects.forEach(item => {
          const obj = jiraProjects.value.find(_ => {
            return _.name === item
          })
          localJiraProject.value.push(obj)
        })
      } else {
        localJiraProject.value = JSON.parse(loc_jira_project)
      }
    } else {
      localJiraProject.value = []
      console.log(data)
      // message.error(retInfo)
    }
  }
  getAllProjects()
  return {
    localJiraProject,
    jiraProjects,
    activeKey
  }
}

// 通过项目ID获取项目详情
export const v1_jira_getProjectById_post_ = function(jiraProjects) {
  const getProjectDetail = async activeKey => {
    const { success, data, retInfo } = await v1_jira_getProjectById_post({
      id: jiraProjects.value[activeKey].id
    })
    if (success) {
      console.log(data)
      message.success(retInfo)
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
}

// 通过jql查询相关信息
export const v1_jira_searchByJQL_post_ = function() {
  const searchResults = ref([])
  const executeSearchByJQL = async params => {
    const { success, data, retInfo } = await v1_jira_searchByJQL_post(params)
    if (success) {
      searchResults.value = data.issues
    } else {
      searchResults.value = []
    }
  }
  return {
    executeSearchByJQL,
    searchResults
  }
}
